import React from 'react';
import { MyGameProfile as MyGameProfileComponent } from '../../organisms/game-profile/MyGameProfile';

export const MyGameProfile: React.FC = () => {
  return <MyGameProfileComponent />;
};
